import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { Params } from './types';

type ExportToPortfoliosAppProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  widgetPaths: Record<string, string>;
  jobId: number;
  params: Params;
  setParams: (_p: Params) => void;
};

const ExportToPortfoliosApp = ({ id, widgetPaths, jobId, params, setParams, mode }: ExportToPortfoliosAppProps) => {
  const renderJobComponent = () => (
    <Chart id={id} jobId={jobId} file={widgetPaths['backtest_app_portfolio_export']} params={params} />
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default ExportToPortfoliosApp;
